module.exports = __webpack_public_path__ + "static/media/reminder-feedback-image.8aa9dfe9.svg";